import { useState } from "react";
import { post } from "../networking/RequestService";

const useTaskDelete = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const deleteTask = async (taskId) => {
        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "gorevSil",
                gorev: taskId,
                guncelleProfilId: "",
                multiple: false,
            });
            return res.data;
        } catch (res) {
            setError(res?.data?.text);
            throw res.data.text;
        } finally {
            setLoading(false);
        }
    };

    const bulkDeleteTasks = async (taskIds) => {
        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "gorevSil",
                gorev: taskIds,
                guncelleProfilId: "",
                multiple: true,
            });
            return res.data;
        } catch (res) {
            setError(res?.data?.text);
            throw res.data.text;
        } finally {
            setLoading(false);
        }
    };

    return { deleteTask, bulkDeleteTasks, loading, error };
};

export default useTaskDelete;
